import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { FONT_SIZE_LEVELS } from '@readsavor/utils';
import { Button } from '../core/index.js';
/**
 * A UI component for selecting font size via + and - buttons.
 * It translates a scale factor into user-friendly font size levels.
 */
export const FontSizeSelector = ({ currentScale, onScaleChange, }) => {
    const currentLevel = useMemo(() => {
        // Find the closest level to the current scale
        return FONT_SIZE_LEVELS.reduce((prev, curr) => Math.abs(curr.scale - currentScale) < Math.abs(prev.scale - currentScale) ? curr : prev);
    }, [currentScale]);
    const handleDecrement = useCallback(() => {
        const currentIndex = FONT_SIZE_LEVELS.findIndex(level => level.level === currentLevel.level);
        if (currentIndex > 0) {
            onScaleChange(FONT_SIZE_LEVELS[currentIndex - 1].scale);
        }
    }, [currentLevel, onScaleChange]);
    const handleIncrement = useCallback(() => {
        const currentIndex = FONT_SIZE_LEVELS.findIndex(level => level.level === currentLevel.level);
        if (currentIndex < FONT_SIZE_LEVELS.length - 1) {
            onScaleChange(FONT_SIZE_LEVELS[currentIndex + 1].scale);
        }
    }, [currentLevel, onScaleChange]);
    const isMinSize = currentLevel.level === FONT_SIZE_LEVELS[0].level;
    const isMaxSize = currentLevel.level === FONT_SIZE_LEVELS[FONT_SIZE_LEVELS.length - 1].level;
    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Button, { variant: "text", size: "small", onClick: handleDecrement, disabled: isMinSize, "aria-label": "Decrease font size", className: "p-1", children: _jsx("span", { className: "text-lg font-semibold", children: "-" }) }), _jsx("span", { className: "text-sm font-medium text-gray-600 w-16 text-center tabular-nums", children: currentLevel.name }), _jsx(Button, { variant: "text", size: "small", onClick: handleIncrement, disabled: isMaxSize, "aria-label": "Increase font size", className: "p-1", children: _jsx("span", { className: "text-lg font-semibold", children: "+" }) })] }));
};
//# sourceMappingURL=FontSizeSelector.js.map